"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveValues = resolveValues;
/**
 * Given an object whose values are Resolvable, returns an object of the same
 * shape, with all the Promises resolved.
 * @param promiseValues An object whose values are Resolvable.
 * @returns An object with all the Promise values resolved. Rejects if any of the values reject.
 */
async function resolveValues(promiseValues) {
    const keys = Object.keys(promiseValues);
    const values = await Promise.all(Object.values(promiseValues));
    return keys.reduce((result, key, currentIndex) => {
        result[key] = values[currentIndex];
        return result;
    }, {});
}
//# sourceMappingURL=resolve-values.js.map